import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { PublicMaintenanceMessage } from '../model/maintenance-message'
import { RestService } from './rest'

@Injectable({
  providedIn: 'root',
})
export class MaintenanceMessageService {
  constructor(private restService: RestService) {}

  getActive(clinicId: string): Observable<PublicMaintenanceMessage[]> {
    return this.restService.get<PublicMaintenanceMessage[]>(`/maintenance-messages/${clinicId}/active`, this.cacheBustParams()).pipe(
      map((resp) => resp.data),
    )
  }

  getActiveGlobal(): Observable<PublicMaintenanceMessage[]> {
    return this.restService.get<PublicMaintenanceMessage[]>('/maintenance-messages/global/active', this.cacheBustParams()).pipe(
      map((resp) => resp.data),
    )
  }

  // browsers can serve GETs like this straight from disk cache on a normal refresh; force a network hit
  private cacheBustParams(): HttpParams {
    return new HttpParams().set('_', Date.now().toString())
  }
}
